export const optionsMap = [
  {
    options: 0,
    label: 'Too weak!',
  },
  {
    options: 1,
    label: 'Too weak!',
  },
  {
    options: 2,
    label: 'Weak',
  },
  {
    options: 3,
    label: 'Medium',
  },
  {
    options: 4,
    label: 'Strong',
  }
];